// Clickable Airhead Games mark + wordmark: main header shell and compact surfaces (e.g. library sidebar).

import React from 'react';
import { Link } from 'react-router';
import { ASSETS } from '@airhead-games/shared/configs/assets';
import { cn } from '@/utilities/cn';
import { analyticsService } from '../../services/analyticsService';

interface LogoProps {
  className?: string;
  variant?: 'header' | 'sidebar';
  beatTint?: boolean; /** Home scroll beat only: wordmark uses scoped `--primary`; otherwise white (default + inner pages). Ignored when `variant="sidebar"`. */
}

const Logo: React.FC<LogoProps> = ({
  className,
  variant = 'header',
  beatTint,
}) => {
  const handleClick = () => {
    analyticsService.trackButtonClick(
      'Logo',
      variant === 'sidebar' ? { link_location: 'library_sidebar' } : undefined
    );
  };

  const isSidebar = variant === 'sidebar';

  return (
    <Link
      to="/"
      title="Go to Homepage"
      aria-label="Go to Airhead Games Homepage"
      onClick={handleClick}
      className={cn(
        'flex min-w-0 shrink-0 items-center no-underline hover:no-underline',
        isSidebar
          ? 'gap-1.5 text-sidebar-foreground'
          : 'gap-2 sm:gap-3 lg:gap-4',
        !isSidebar && (beatTint ? 'text-primary' : 'text-white'),
        className
      )}
    >
      <img
        src={ASSETS.logoHoleFit}
        alt=""
        aria-hidden="true"
        className={cn(
          'block w-auto',
          isSidebar ? 'h-7' : 'h-10 sm:h-12 lg:h-14 xl:h-16'
        )}
      />
      {/* Modak has a tall ascender and low baseline — nudge down so it optically centers on the logo. */}
      <span
        className={cn(
          'translate-y-[0.12em] font-modak uppercase leading-none',
          isSidebar
            ? 'text-xl tracking-wide'
            : 'text-2xl sm:text-3xl lg:text-4xl xl:text-5xl'
        )}
      >
        Airhead Games
      </span>
    </Link>
  );
};

export default Logo;
